
import './App.css';
import React from "react"
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Appbar from '../src/Appbar'
import { Box } from '@mui/material';
import Dashboard from '../src/Dashboard'
import Settings from './Settings';
import Orders from './Orders';
import Login from './Login';


function App() {
  return (
    <div>
     
    <Box sx={{backgroundColor:'#f2f2f2',minHeight:'100vh',width:'100%'}}> 
<Appbar/>

  <React.StrictMode>
    <RouterProvider router={createBrowserRouter([



    {
      path: "/" ,
      element:<Login/>,
    },

    {
      path: "/dashboard" ,
      element:<Dashboard/>,
    },

        {
      path: "/orders" ,
      element:<Orders/>,
    },

        {
      path: "/settings" ,
      element:<Settings/>,
    },











    

    
])} />

</React.StrictMode>
    </Box>


    </div>
  );
}

export default App;
